import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SerialNoCellComponent } from '../../table-cell/serial-no-cell.component';
import { MasterSearchTransmissionService } from '../../services/raintree/Transmission/master-search.service';
import {
  GlobalRespo,
  GlobalResponseData,
} from '../../services/raintree/interfaces/global-respo';
import { DpTableComponent } from '../../common-component/dp-table/dp-table.component';
import { GlobalSearchTabComponent } from './global-search-tab/global-search-tab.component';
import { NameSearchTabComponent } from './name-search-tab/name-search-tab.component';
import { KeywordSearchTabComponent } from './keyword-search-tab/keyword-search-tab.component';
import { NamesToUpdateService } from '../../services/raintree/Transmission/names-to-update.service';

@Component({
  selector: 'master-search-dialog',
  standalone: true,
  templateUrl: './master-search-dialog.component.html',
  styleUrl: './master-search-dialog.component.scss',
  imports: [
    CommonModule,
    GlobalSearchTabComponent,
    NameSearchTabComponent,
    KeywordSearchTabComponent,
    MatDialogModule,
  ],
})
export class MasterSearchDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MasterSearchDialogComponent>,
    private _namesToUpdateService: NamesToUpdateService,
    private _masterSearchService: MasterSearchTransmissionService
  ) {}
  activeTab: string = 'globalSearch';

  onClickSerialNo(event: any) {
    let bodyObj = {
      dpwMemKey: event,
      uiState: this.data.uiState,
      uiDistrict: this.data.uiDistrict,
    };
    this._namesToUpdateService
      .updateSerialNo(this.data.memberId, bodyObj)
      .subscribe({
        next: (response: any) => {
          this.dialogRef.close(event);
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  onClose() {
    this.dialogRef.close();
  }
}
